import React from 'react';
import { Typography } from '@growthaxl/web-foundation';
import type { ComparisonBlock } from '../../types';

export interface ComparisonBlockViewProps {
  block: ComparisonBlock;
}

export function ComparisonBlockView({ block }: ComparisonBlockViewProps): React.ReactElement {
  return (
    <div data-testid="block-comparison" className="grid grid-cols-1 sm:grid-cols-2 gap-2">
      {block.options.map((option, i) => (
        <div key={i} className="border border-border-default rounded-8 px-3 py-2.5 flex flex-col gap-1">
          <Typography variant="subtitle2" color="primary">
            {option.label}
          </Typography>
          {option.detail && (
            <Typography variant="body2" color="secondary">
              {option.detail}
            </Typography>
          )}
        </div>
      ))}
    </div>
  );
}
